import React from 'react';
import {
  TestsConnectorApollo,
  RemoveTestConnectorApollo,
} from '@front-activerse/common-components';
import LabTestsContainer from './LabTestsContainer';

const TestsPage: React.FC = () => {
  return (
    <TestsConnectorApollo>
      {({ ...testData }) => (
        <RemoveTestConnectorApollo>
          {({ removeTest }) => <LabTestsContainer {...testData} removeTest={removeTest} />}
        </RemoveTestConnectorApollo>
      )}
    </TestsConnectorApollo>
  );
};

export default TestsPage;
